<template>
  <header class="pt-10 pb-2">
    <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <nav class="relative z-50 flex justify-between">
        <div class="flex items-center md:gap-12">
          <a aria-label="Home" :href="clientWebUrl"
            ><div class="flex items-center gap-2">
              <img
                src="/logo.png"
                alt="Logo"
                loading="lazy"
                width="36"
                height="36"
                decoding="async"
                data-nimg="1"
                style="color:transparent"
              /><span class="font-bold text-blue-500"
                >Scaffold<span class="text-blue-500"
                  >Hub</span
                ></span
              >
            </div></a
          >
          <div class="hidden md:flex md:gap-6">
            <a
              class="inline-block rounded-lg px-2 py-1 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
              :href="clientWebUrl + '/#features'"
              >Features</a
            ><a
              class="inline-block rounded-lg px-2 py-1 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
              :href="clientWebUrl + '/#pricing'"
              >Pricing & FAQ</a
            ><a
              class="inline-block rounded-lg px-2 py-1 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
              href="https://felipepastorelima.gitbook.io/scaffoldhub-v3"
              >Documentation</a
            ><a
              class="inline-block rounded-lg px-2 py-1 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
              href="https://v3.scaffoldhub.io/scaffold/nodejs"
              >Modeling Tool</a
            >
          </div>
        </div>
        <div class="flex items-center gap-5 md:gap-8">
          <div
            class="hidden md:block"
            v-if="!loading && !authenticated"
          >
            <router-link
              to="/auth/sign-in"
              class="inline-block rounded-lg px-2 py-1 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
            >
              Sign in
            </router-link>
          </div>
          <div class="relative" v-if="authenticated">
            <button
              class="inline-block rounded-lg px-2 py-1 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
              @click.stop="userMenuOpened = !userMenuOpened"
            >
              Account
              <i class="ml-1 fas fa-chevron-down"></i>
            </button>

            <div
              v-if="userMenuOpened"
              class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg"
              v-click-outside="onClose"
              @click="onClose"
            >
              <div class="rounded-md bg-white shadow-xs">
                <div
                  class="py-1"
                  role="menu"
                  aria-orientation="vertical"
                  aria-labelledby="options-menu"
                >
                  <div class="px-4 py-3">
                    <p class="text-sm leading-5">
                      Signed in as
                    </p>
                    <p
                      class="text-sm leading-5 font-medium text-gray-900"
                    >
                      {{ currentUser.email }}
                    </p>
                  </div>

                  <div
                    class="border-t border-gray-100"
                  ></div>

                  <router-link
                    v-if="currentUser.affiliateId"
                    to="/affiliate"
                    class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                    >Affiliate</router-link
                  >

                  <router-link
                    to="/project"
                    class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                    role="menuitem"
                    >Projects
                  </router-link>
                  <router-link
                    to="/auth/account"
                    class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                    role="menuitem"
                    >Account
                  </router-link>

                  <div
                    class="border-t border-gray-100"
                  ></div>
                  <a
                    href="https://felipepastorelima.gitbook.io/scaffoldhub-v3/changelog/scaffold"
                    class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                    role="menuitem"
                    >Changelog
                  </a>
                  <a
                    href="https://felipepastorelima.gitbook.io/scaffoldhub-v3/support"
                    class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                    role="menuitem"
                    >Support
                  </a>
                  <a
                    href="https://scaffoldhub.io/license"
                    class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                    role="menuitem"
                    >License
                  </a>
                  <div
                    class="border-t border-gray-100"
                  ></div>
                  <button
                    type="button"
                    class="block w-full text-left px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                    role="menuitem"
                    @click="signOut()"
                  >
                    Sign out
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
import config from '@/config';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'app-header',

  data() {
    return {
      userMenuOpened: false,
    };
  },

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      currentUser: 'auth/currentUser',
      loading: 'auth/loading',
      credits: 'credits/credits',
      creditsInitializing: 'credits/initializing',
      premium: 'credits/premium',
    }),

    clientWebUrl() {
      return config.CLIENT_WEB_URL;
    },
  },

  methods: {
    ...mapActions({
      signOut: 'auth/signOut',
    }),

    onClose() {
      this.userMenuOpened = false;
    },
  },
};
</script>

<style></style>
